export const FATHOM_SITE_ID = "NQPJWSHY";

export const FATHOM_SCRIPT_URL = "https://satellite.planity.events/script.js";

export const ALLOWED_DOMAINS = [
  "planity.events",
  "planity.nyc",
  "planitynyc.com",
];
